import { useEffect } from "react";

import useGetScrollbarWidth from "hooks/useGetScrollbarWidth/useGetScrollbarWidth";

const useDisableScroll = (disabled: boolean) => {
    const scrollbarWidth = useGetScrollbarWidth();
    const disableScroll = (element: HTMLElement): void => {
        element.style.overflow = "clip";
        element.style.paddingRight = `${scrollbarWidth}px`;
    };

    const enableScroll = (element: HTMLElement): void => {
        element.style.overflow = "auto";
        element.style.removeProperty("padding-right");
    };

    useEffect(() => {
        const $document = document.documentElement;

        if (disabled) {
            disableScroll($document);
        } else {
            enableScroll($document);
        }
    }, [disabled]);
};

export default useDisableScroll;
